import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-sidenav-menu-title',
  styleUrls: ['./sidenav-menu-title.component.scss'],
  templateUrl: './sidenav-menu-title.component.html',
})
export class SidenavMenuTitleComponent {
  @Input() value: string | null | undefined;
}
